import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useGetWebPageQuery } from '../../../api/queries/getWebPage';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import WebpageDetails from './WebpageDetails';

const WebpageDetailsPage = () => {
    const { webpageId } = useParams<{ webpageId: string }>();

    const { data, loading } = useGetWebPageQuery({
        fetchPolicy: 'network-only',
        variables: { id: webpageId, productionOnly: false },
    });

    const webPage = useMemo(() => data?.webpage, [data?.webpage]);

    if (!webPage && loading) {
        return <LoadingElement />;
    }

    if (!webPage) {
        return <NotFoundResult />;
    }

    return <WebpageDetails webpage={webPage} />;
};

export default WebpageDetailsPage;
